import './index.scss'

import { Controller as BaseController } from 'stimulus'
import { getCollapsedState, setCollapsedState } from '@app/javascript/classes/collapsibleCard'

export class Controller extends BaseController {
  static targets = ['self', 'icon']
  static classes = ['collapsed']

  static values = {
    cardTitle: String
  }

  connect() {
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('h-transform-rotate-180', this.collapsed)
      this.selfTarget.classList.toggle(this.collapsedClass, !!this.collapsed)
    }
  }

  toggle() {
    this.collapsed = !this.collapsed
    this.iconTarget.classList.toggle('h-transform-rotate-180')
    this.selfTarget.classList.toggle(this.collapsedClass)
  }

  get collapsed() {
    return getCollapsedState(this.cardTitleValue)
  }

  set collapsed(value) {
    return setCollapsedState(this.cardTitleValue, value)
  }
}
